import { memo } from "react";
import PropTypes from "prop-types";
import "./ProductBadge.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ProductBadge = ({ label }) => {
	return label ? (
		<Typography
			data-testid="product-badge"
			variant={TYPOGRAPHY_VARIANTS.SMALL}
			component="span"
			className="product-badge"
		>
			{label}
		</Typography>
	) : null;
};

ProductBadge.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

export default memo(ProductBadge);
